import React from "react";

const Monday = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g clipPath="url(#mondaya)">
            <path
                d="M5.98 27.24a3.994 3.994 0 0 1-3.482-2.026 3.884 3.884 0 0 1 .11-3.99L9.779 9.932A3.996 3.996 0 0 1 13.32 8a3.99 3.99 0 0 1 3.427 2.119 3.88 3.88 0 0 1-.216 3.983L9.363 25.397a3.995 3.995 0 0 1-3.382 1.844Z"
                fill="#F62B54"
            />
            <path
                d="M18.282 27.24a3.982 3.982 0 0 1-3.476-2.021 3.872 3.872 0 0 1 .109-3.979l7.158-11.268a3.99 3.99 0 0 1 3.543-1.97c1.459.032 2.78.85 3.45 2.13a3.872 3.872 0 0 1-.259 4.001l-7.156 11.268a3.988 3.988 0 0 1-3.369 1.84Z"
                fill="#FC0"
            />
            <path
                d="M30.308 27.335c2.04 0 3.692-1.623 3.692-3.625s-1.653-3.625-3.692-3.625-3.692 1.623-3.692 3.625 1.653 3.625 3.692 3.625Z"
                fill="#00CA72"
            />
        </g>
        <defs>
            <clipPath id="mondaya">
                <path fill="#fff" transform="translate(2 8)" d="M0 0h32v19.556H0z" />
            </clipPath>
        </defs>
    </svg>
);

export default Monday;
